<template>
    <span v-if="this.vType" class="text-center">
        {{ this.vTypeName }}
    </span>
</template>

<script>
export default {
    props: {
        vType: {
            default: null
        }
    },
    computed: {
        vTypeName: function () {
            switch (this.vType) {
                case 'VOITURE':
                    return 'Voiture'
                case 'SCOOTER':
                    return 'Scooter'
                case 'MOTO':
                    return 'Moto'
                case 'CAMION':
                    return 'Camion'
                case 'CAMIONETTE':
                    return 'Camionette'
                case 'REMORQUE':
                    return 'Remorque'
                case 'AUTRE':
                    return 'Autre'
                default:
                    return null
            }
        },
    },
}
</script>
